<template>
  <div class="certificate">
    <img
      class="certificate-banner"
      src="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/banner.png"
      alt
    />
    <!-- 一级菜单栏 -->
    <div class="about-menu">
      <ul>
        <router-link
          v-for="(item,index) in menuList"
          :key="index"
          :to="item.path"
          :class="activeName == item.path ? 'about-menu-active' : 'about-menu-noactive'"
          @click="menuClick(index)"
        >
          <li>{{item.name}}</li>
        </router-link>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>   

<script>
export default {
  components: {},
  data() {
    return {
      activeName: 0,
      /**
       * id:一级分类id 用于查询子id
       * name:一级分类名称
       * en:英文单词,用于左侧列表显示板块
       * path:路由(保留)
       */
      menuList: [
        {
          id: "137",
          name: "政策标准",
          path: "/certificatechildren",
        },
        {
          id: "138",
          name: "通知公告",
          path: "/notice",
        },
        {
          id: "139",
          name: "师资培训",
          path: "/train",
        },
        {
          id: "140",
          name: "教学资源",
          path: "/resource",
        },
        {
          id: "141",
          name: "证书信息",
          path: "/certificateInfo",
        },
        {
          id: "142",
          name: "学分银行",
          path: "/creditbank",
        },
        {
          id: "143",
          name: "信息查询",
          path: "/inqure",
        },
      ],
     
    };
  },
  
 watch: {},
  created() {},
  mounted() {
    this.activeName = this.$route.path;
  },
  watch: {
    $route(route) {
      this.activeName = route.path;
    },
  },
  methods: {  },
};
</script>

<style>
.certificate {
  position: relative;
  background: #eee;
}

.certificate-banner {
  width: 100%;
  height: 450px;
}

.certificate-title {
  position: absolute;
  top: 208px;
  width: 100%;
  text-align: center;
  color: #fff;
}

.certificate-title h1 {
  font-size: 50px;
}

.certificate-title p {
  font-size: 24px;
  margin-top: 10px;
}

.certificate-menu {
  width: 1190px;
  background: #fff;
  position: absolute;
  top: 410px;
  height: 80px;
  left: 50%;
  margin-left: -600px;
}

.certificate-menu ul {
  display: flex;
}

.certificate-menu li {
  width: 170px;
  cursor: pointer;
  height: 80px;
  font-size: 16px;
  text-align: center;
  line-height: 80px;
}

.certificate-menu .certificate-menu-active {
  background: #0a57f4;
  color: #fff;
}

.certificate-menu-active {
  color: #0a57f4;
}

.certificate-menu .certificate-menu-noactive {
  background: #fff;
  color: #333;
}

.certificate-list {
  width: 1200px;
  min-height: 450px;
  margin: 0 auto;
}

.certificate-list-left {
  float: left;
  width: 185px;
  /* min-height: 450px; */
}

.toobar {
  height: 78px;
  padding-top: 30px;
  border-bottom: 1px solid #6d5c55;
}

.eng {
  font-size: 16px;
  color: #666666;
}

.eng-font {
  font-size: 26px;
}

.column1 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}

.column2 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  color: #0055d3;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}

.column1:hover,
.column2:hover {
  color: #0055d3;
  cursor: pointer;
}

.certificate-list-right {
  position: relative;
  display: inline-block !important;
  width: 1014px;
  height: auto;
  border-left: 1px solid #d4d4d4;
}

.source-list1 {
  min-height: 520px;
  margin-top: 50px;
  margin-left: 70px;
  margin-bottom: 100px;
}

.source-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 520px;
  margin-top: 50px;
  margin-left: 70px;
  margin-bottom: 80px;
}

.source-list img:hover {
  transition: all 0.5s;
  transform: scale(1.02);
}

.source-list-item {
  display: flex;
  justify-content: space-between;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #666666;
  border-bottom: 1px #eeeeee solid;
}

.source-list-item-title img {
  margin-top: -2px;
  vertical-align: middle;
  display: inline-block;
  margin-left: 8px;
}

.certificate-info {
  min-height: 450px;
  margin-top: 50px;
  margin-left: 50px;
}

.certificate-info-img {
  width: 100%;
  height: 292px;
  background-image: url(http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/zhengshu.png);
}

.certificate-info-menu {
  color: #666666;
  height: 80px;
}

.certificate-info-menu ul {
  display: flex;
}

.certificate-info-menu li {
  width: 100px;
  cursor: pointer;
  height: 80px;
  font-size: 16px;
  text-align: center;
  line-height: 80px;
}

.hr {
  height: 4px;
  background: #ededed;
}

.certificate-info-content {
  line-height: 30px;
  margin-top: 40px;
  margin-bottom: 100px;
  color: #666666;
}

.certificate-info-content3 {
  margin-top: 40px;
  height: 574px;
  color: #666666;
}

.certificate-info-content3 tr {
  height: 50px;
  background: #eaf2ff;
}

.certificate-info-content3 tr:nth-child(2n + 1) {
  background: #fafafa;
}

.titleList {
  height: auto;
  width: auto;
  margin-top: 30px;
}

.tabChangeInfo {
  margin-top: 30px;
}

/*//新增*/
.tablecont {
  width: 100%;
  margin-left: 50px;
}

.serchbox {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 14px;
}

.serchitem {
  margin: 0 20px;
  display: flex;
  line-height: 40px;
}

.serchbtn {
  width: 120px;
  height: 40px;
  line-height: 40px;
  background-color: #0055d3;
  color: white;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 20px;
}

.serchinput {
  width: 120px;
  height: 40px;
  padding: 2px 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-left: 10px;
}

.serchinput > input {
  border: none;
  outline: none;
  width: 100%;
  height: 80%;
  position: relative;
  top: -4px;
}

.studentinfo {
  width: 92%;
  background-color: rgb(246, 249, 254);
  border-top: 1px solid rgb(200, 219, 250);
  border-left: 1px solid rgb(200, 219, 250);
  margin-top: 30px;
  font-size: 14px;
  margin-bottom: 30px;
}

.infoitem {
  width: 100%;
  display: flex;
  text-align: center;
  border-bottom: 1px solid rgb(200, 219, 250);
}

.infoname,
.infoval {
  width: 40%;
  border-right: 1px solid rgb(200, 219, 250);
  padding: 15px 0;
}

.infoval_color {
  width: 60%;
  border-right: 1px solid rgb(200, 219, 250);
  padding: 15px 0;
  color: red;
}

.infoval {
  width: 60%;
}

.title {
  display: flex;
  margin-left: 50px;
  width: auto;
  height: 85px;
}

.title:hover {
  background-color: #0055d3;
  color: #e6e6e6;
  cursor: pointer;
}

.title-left1 {
  color: #0055d3;
  height: auto;
  width: 175px;
  font-size: 32px;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 25px;
}

.title-left2 {
  color: #e6e6e6;
  height: auto;
  width: 175px;
  font-size: 32px;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 25px;
}

.title-right {
  height: auto;
  padding-top: 13px;
  margin-left: 12px;
  vertical-align: middle;
  line-height: 30px;
}

.title-title {
  font-size: 18px;
  font-weight: bold;
}

.title-brief {
  font-size: 14px;
}

.title-page {
  display: flex;
  justify-content: space-between;
  width: auto;
  padding: 0px 20px 0px 75px;
  margin: 90px 0px 70px;
}

.title-page .box {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin-right: 2px;
  font-size: 16px;
  color: #333;
  background: #ddd;
}

.box:hover {
  cursor: pointer;
}

.title-page .flex {
  display: flex;
}

.title-page .active {
  color: #fff;
  background: #0055d3;
}

.title-page-active:active {
  background: #0055d3;
  color: #fff;
}

.train {
  min-height: 800px;
  width: 1200px;
  margin: 0 auto;
}

.video-title,
.course-title {
  margin-top: 60px;
  margin-bottom: 40px;
  text-align: center;
}

.video {
  display: flex;
  justify-content: space-between;
}

.video-show {
  height: 92px;
  width: 92px;
  margin: -265px 0 0 427px;
  position: relative;
  z-index: 3;
  display: block;
}

.video-hidden {
  height: 92px;
  width: 92px;
  margin: -313.5px 0 0 427px;
  position: relative;
  z-index: 3;
  display: none;
}

.video-main {
  height: 532px;
  width: 946px;
  background-color: #999999;
}

.video-main-title {
  font-size: 24px;
  color: #ffffff;
  position: relative;
  z-index: 2;
  margin-top: -95px;
  margin-left: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.bofang1:hover {
  cursor: pointer;
}

.video-mini {
  width: 225px;
  height: 532px;
  position: relative;
}

.video-mini ul {
  overflow: hidden;
  width: 225px;
  height: 532px;
}

.video-mini li {
  height: 126px;
  width: 225px;
  background: #999999;
  position: relative;
  cursor: pointer;
  margin-bottom: 10px;
}

.video-mini-title {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
  letter-spacing: 1px;
  font-size: 14px;
  color: #ffffff;
  z-index: 3;
  position: absolute;
  margin-top: -22px;
  margin-left: 6px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.video-mini-title1 {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
  letter-spacing: 1px;
  font-size: 14px;
  color: #f25b20;
  z-index: 3;
  position: absolute;
  margin-top: -22px;
  margin-left: 6px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.video-mini-img {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
  letter-spacing: 1px;
  font-size: 14px;
  z-index: 3;
  position: absolute;
  margin-top: -76px;
  margin-left: 102px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.arrow-up {
  position: absolute;
  width: 225px;
  height: 25px;
  background: #f4f4f4;
  margin-top: -565px;
  text-align: center;
  cursor: pointer;
}

.arrow-down {
  width: 225px;
  height: 25px;
  background: #f4f4f4;
  position: absolute;
  margin-top: 6px;
  text-align: center;
  cursor: pointer;
}

.revolve {
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  display: block;
  color: #2d73d9;
  font-size: 20px;
  width: 25px;
  margin: auto;
}

.video-mini-item {
}

/* .down-list{
		height: 500px;
	} */

.down-item {
  height: 80px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px #cccccc solid;
  line-height: 80px;
}

.icon {
  width: 26px;
  height: 26px;
}

.down-item-left {
  color: #333333;
  margin-left: 20px;
}

.down-item-left img {
  margin-top: -4px;
  vertical-align: middle;
  display: inline-block;
  margin-right: 20px;
}

.down-item-right {
  margin: auto 0;
  margin-right: 20px;
}

.down-item-right p {
  width: 136px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 2px solid #0055d3;
  border-radius: 30px;
  background: #fff;
  cursor: pointer;
}

.down-item-right p:hover {
  background: #0055d3;
  color: #fff;
}

.bank {
  width: 1200px;
  min-height: 300px;
  display: flex;
  margin: 45px auto 150px;
}

.bank-left {
  width: 385px;
  height: 398px;
  background: url(http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/xuefen.png)
    repeat 100% 100%;
}

.bank-left:hover {
  cursor: pointer;
}

.bank-right {
  line-height: 29px;
  font-size: 18px;
  margin-left: 50px;
  width: 766px;
}

.source-list-item-title a {
  color: #333;
}

.source-list-item-title a:hover {
  color: #0a57f4;
}

.rado {
  height: 30px;
  display: inline-block;
  margin-left: 10px;
  background: url(../assets/xuanzhzong_1.png) no-repeat 12px 12px;
  line-height: 34px;
  padding-left: 30px;
  margin-left: 0px;
  font-size: 15px;
}

.rado1 {
  height: 30px;
  display: inline-block;
  margin-left: 10px;
  background: url(../assets/xuanzhong.png) no-repeat 12px 12px;
  line-height: 34px;
  padding-left: 30px;
  margin-left: 0px;
  font-size: 15px;
}

a:hover {
  cursor: pointer;
}

.kai {
  transform: rotate(-90deg);
}

.guan {
  transform: rotate(90deg);
  margin-left: 20px;
}

.searchStyle {
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  margin-top: 40px;
  margin-bottom: 22px;
}
.about-menu {
  width: 1190px;
  background: #fff;
  position: absolute;
  top: 410px;
  height: 80px;
  left: 50%;
  margin-left: -600px;
}
.about-menu ul {
  display: flex;
}
.about-menu li {
  width: 170px;
  cursor: pointer;
  height: 80px;
  font-size: 16px;
  text-align: center;
  line-height: 80px;
}
.about-menu .about-menu-active {
  background: #0a57f4;
  color: #fff;
}
.about-menu .about-menu-noactive {
  background: #fff;
  color: #333;
}
</style>